import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { DocumentsService } from '../../../../core/services/documents.service';

@Component({
  selector: 'elearning-detail',
  templateUrl: './elearning-detail.component.html',
  styleUrls: ['./elearning-detail.component.scss'],
  standalone: false
})

export class ElearningDetailComponent implements OnInit, AfterViewInit {
  @Input() elearning;
  @Input() checkBackground;
  questions: any;
  finishElearning = false;
  totalCount = 0;
  constructor(public documentService: DocumentsService) {
  }

  ngOnInit() {
    if (this.elearning && this.elearning.questions) {
      this.questions = JSON.parse(this.elearning.questions);
    }
    if (this.elearning && this.elearning.answer) {
      this.finishElearning = true;
      this.totalCount =  this.elearning.answer.percentage;
      let answers = JSON.parse(this.elearning.answer.answers);
      for (let i = 0; i < answers.length; i++) {
        let questionIndex = this.questions.findIndex(el => el.id === answers[i].questionId);
        if (questionIndex !== -1) {
          this.questions[questionIndex].userAnswer = answers[i].answer;
          if (this.questions[questionIndex].type === 'text') {
            this.questions[questionIndex].userAnswer = answers[i].answer;
          }
          if (this.questions[questionIndex].type === 'single') {
            this.questions[questionIndex].userAnswer = answers[i].answer;
          }
          if (this.questions[questionIndex].type === 'multiple') {
            for (let c = 0; c < this.questions[questionIndex].answers.length; c++) {
              if (answers[i].answer.indexOf(this.questions[questionIndex].answers[c].text) !== -1) {
                this.questions[questionIndex].answers[c].checked = true;
              }
            }
          }
        }
      }
      this.checkAnswers();
    }
  }

  getFile(name) {
    return this.documentService.getFileStream(name);
  }

  ngAfterViewInit() {
    if (this.checkBackground && this.elearning) {
      this.checkBackgroundColor();
    }
  }

  checkBackgroundColor() {
    const myDivObj: any = document.querySelector('.elearning-page');
    let myDivObjBgColor: any = window.getComputedStyle(myDivObj).backgroundColor;
    myDivObjBgColor = myDivObjBgColor.replace(/[()rgba]/g, '').trim();
    myDivObjBgColor = myDivObjBgColor.split(',');
    const text: any = document.querySelector('.elearning-detail .description');
    const link: any = document.querySelector('.elearning-detail .description a');
    const title: any = document.querySelector('.elearning-detail .title');
    const documents: any = document.querySelector('.elearning-detail .documents');
    const info: any = document.querySelectorAll('.elearning-detail .info-not-main');
    const backButton: any = document.querySelector('.to-view input');
    const messageBox: any = document.querySelectorAll('.message-box');
    const question: any = document.querySelectorAll('.question');
    if ((myDivObjBgColor[0] * 0.299 + myDivObjBgColor[1] * 0.587 + myDivObjBgColor[2] * 0.114) > 186) {
      if (text) { text.style.color = '#000000'; }
      if (title) { title.style.color = '#000000'; }
      if (info && info.length) {
        for (const i of info) {
          i.style.color = '#000000';
        }
      }
      if (link) { link.style.color = '#000000'; }
      if (documents) { documents.style.color = '#000000'; }
      if (messageBox && messageBox.length) {
        for (const m of messageBox) {
          m.style.color = '#37474f';
          m.style.borderColor = '#37474f';
        }
      }
      if (question && question.length) {
        for (const q of question) {
          q.style.color = '#000000';
          q.style.borderColor = '#000000';
        }
      }
      if (backButton) { backButton.style.border = '1px solid grey'; }
      if (backButton) { backButton.style.color = '#000000'; }
    } else {
      if (text) { text.style.color = '#ffffff'; }
      if (title) { title.style.color = '#ffffff'; }
      if (info && info.length) {
        for (const i of info) {
          i.style.color = '#ffffff';
        }
      }
      if (link) { link.style.color = '#ffffff'; }
      if (documents) { documents.style.color = '#ffffff'; }
      if (messageBox && messageBox.length) {
        for (const m of messageBox) {
          m.style.color = '#ffffff';
          m.style.borderColor = '#ffffff';
        }
      }
      if (question && question.length) {
        for (const q of question) {
          q.style.color = '#ffffff';
          q.style.borderColor = '#ffffff';
        }
      }
      if (backButton) { backButton.style.color = '#ffffff'; }
      if (backButton) { backButton.style.border = 'none'; }
    }
  }

  checkAnswers() {
    let answers: any = [];
    this.totalCount = 0;
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i].type === 'text') {
        let correctAnswer = this.questions[i].correctAnswer ? this.questions[i].correctAnswer : '';
        if ((correctAnswer).toLowerCase() === (this.questions[i].userAnswer).toLowerCase()) {
          this.questions[i].isAnswerCorrect = true;
          this.totalCount = this.totalCount + (100/this.questions.length);
        } else {
          this.questions[i].isAnswerCorrect = false;
        }
        answers.push({answer: this.questions[i].userAnswer, questionId: this.questions[i].id});
      }
      if (this.questions[i].type === 'single') {
        let findCorrect = this.questions[i].answers.find(el => el.isCorrect);
        if (findCorrect) {
          if (findCorrect.text === this.questions[i].userAnswer) {
            this.questions[i].isAnswerCorrect = true;
            this.totalCount = this.totalCount + (100/this.questions.length);
          } else {
            this.questions[i].isAnswerCorrect = false;
          }
        }
        answers.push({answer: this.questions[i].userAnswer, questionId: this.questions[i].id});
      }
      if (this.questions[i].type === 'multiple') {
        let findCorrectCount = this.questions[i].answers.filter(el => el.isCorrect).length;
        this.questions[i].isAnswerCorrect = true;
        for (let a= 0; a < this.questions[i].answers.length; a++) {
          if (this.questions[i].answers[a].isCorrect) {
            if (this.questions[i].userAnswer.indexOf(this.questions[i].answers[a].text) !== -1) {
              this.questions[i].answers[a].userAnswerCorrect = true;
              this.totalCount = this.totalCount + ((100/this.questions.length)/findCorrectCount);
            } else {
              this.questions[i].answers[a].userAnswerCorrect = false;
              this.questions[i].isAnswerCorrect = false;
            }
          } else {
            if (this.questions[i].userAnswer.indexOf(this.questions[i].answers[a].text) !== -1) {
              this.questions[i].answers[a].userAnswerUncorrect = true;
              this.questions[i].isAnswerCorrect = false;
              this.totalCount = this.totalCount - ((100/this.questions.length)/(findCorrectCount*2));
            }
          }
        }
        answers.push({answer: this.questions[i].userAnswer, questionId: this.questions[i].id});
      }
    }
    return answers;
  }

  changeText(event, questionId) {
    let questionIndex = this.questions.findIndex(el => el.id === questionId);
    if (questionIndex !== -1) {
      this.questions[questionIndex].userAnswer = event.value;
    }
  }

  changeSingle(event, questionId) {
    let questionIndex = this.questions.findIndex(el => el.id === questionId);
    if (questionIndex !== -1) {
      this.questions[questionIndex].userAnswer = event.value;
    }
  }

  changeMulti(event, questionId){
    let questionIndex = this.questions.findIndex(el => el.id === questionId);
    if (questionIndex !== -1) {
      if (!this.questions[questionIndex].hasOwnProperty('userAnswer')) {
        this.questions[questionIndex].userAnswer = [];
      }
      if (!event.checked) {
        let answerIndex = this.questions[questionIndex].userAnswer.findIndex(an => an === event.source.value);
        if (answerIndex !== -1) {
          this.questions[questionIndex].userAnswer.splice(answerIndex, 1);
        }
      } else {
        let answerIndex = this.questions[questionIndex].userAnswer.findIndex(an => an === event.source.value);
        if (answerIndex === -1) {
          this.questions[questionIndex].userAnswer.push(event.source.value);
        }
      }
    }
  }
}
